import { IWebviewBridge, IWebviewCallback } from '../../typings/webview';
import { IJsbridge, IRegisterHandlerCb } from '../../typings';
// 代码来源： https://juejin.im/entry/5ab2202f6fb9a028ca52db0a

function setupWebViewJavascriptBridge(callback: IWebviewCallback) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  const WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(() => {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}

export default {
  callHandler(name: string, data: any) {
    // 返回 promise
    return new Promise((resolve, reject) => {
      setupWebViewJavascriptBridge((bridge: IWebviewBridge) => {
        bridge.callHandler(
          name,
          data,
          (result) => {
            resolve(result);
          });
      });
    });
  },

  registerHandler(name: string, callback: IRegisterHandlerCb) {
    setupWebViewJavascriptBridge((bridge) => {
      bridge.registerHandler(
        name,
        (data: any, responseCallback: any) => {
          callback(data, responseCallback);
        });
    });
  },
} as IJsbridge;
